// @catalog F.030
// Panel lateral de drill-down de una tienda en /margenes. Extraído de
// MarginsLevel1.tsx para respetar P7 (≤500 líneas/archivo).
import { Box, Stack, Typography } from "@mui/material";
import MarginsService, {
  type StoreMarginMetrics,
} from "../../services/margins.service";
import { DrillPanel, StatGrid } from "../analytics/DrillPanel";

export function StoreMarginDrillPanel(props: {
  item: StoreMarginMetrics | null;
  currentLabel: string;
  onClose: () => void;
}): JSX.Element {
  const { item, currentLabel, onClose } = props;
  return (
    <DrillPanel
      open={item !== null}
      title={item ? item.storeName : ""}
      subtitle={item ? `Tienda · ${currentLabel}` : undefined}
      onClose={onClose}
    >
      {item && (
        <Stack spacing={2}>
          <StatGrid
            items={[
              {
                label: "Margen %",
                value: `${item.avgMarginPercentage.toFixed(1)}%`,
                helper:
                  item.realMarginPercentage !== undefined
                    ? `Real ${item.realMarginPercentage.toFixed(1)}%`
                    : undefined,
              },
              {
                label: "Margen $",
                value: MarginsService.formatCurrency(item.totalMarginAmount),
              },
              {
                label: "Ventas",
                value: MarginsService.formatCurrency(item.totalRevenue),
              },
              {
                label: "Descuentos",
                value: MarginsService.formatCurrency(item.totalDiscounts),
              },
            ]}
          />
          {item.bestMarginProduct && (
            <Typography
              variant="body2"
              sx={{ color: "var(--ink-2)", fontSize: "13px" }}
            >
              <Box component="strong">Mejor margen:</Box>{" "}
              {item.bestMarginProduct}
            </Typography>
          )}
          {item.worstMarginProduct && (
            <Typography
              variant="body2"
              sx={{ color: "var(--ink-2)", fontSize: "13px" }}
            >
              <Box component="strong">Peor margen:</Box>{" "}
              {item.worstMarginProduct}
            </Typography>
          )}
        </Stack>
      )}
    </DrillPanel>
  );
}
